module.exports = __webpack_public_path__ + "img/insert-one-product.fe36bde2.png";